import { Box } from '@mui/material'
import { lazy, Suspense } from 'react'
import { Dialogs } from '../../../../sharedComponents/src/Contexts/DialogsContext'
import BaseDialog from '../../../../sharedComponents/src/Dialogs/Common/BaseDialog'
import { useScreenSize } from '../../../../sharedComponents/src/hooks/useScreenSize'

const MobileAppBanner = lazy(() => import('./MobileAppBanner').then((module) => ({ default: module.MobileAppBanner })))
const DesktopAppBanner = lazy(() =>
    import('./DesktopAppBanner').then((module) => ({ default: module.DesktopAppBanner })),
)

export const AppStorePopup = ({ onClose }) => {
    const { isMobile } = useScreenSize()

    return (
        <BaseDialog name={Dialogs.MISSIONS_APP_STORE} verticalCentered paddingLess onClose={onClose}>
            <Box display="flex" maxHeight="100%" maxWidth="100%" height="100%" width="100%" justifyContent="center">
                <Suspense fallback={<div>Loading...</div>}>
                    {isMobile ? <MobileAppBanner /> : <DesktopAppBanner />}
                </Suspense>
            </Box>
        </BaseDialog>
    )
}
